import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2017-2022 @polkadot/vue-identicon authors & contributors
// SPDX-License-Identifier: Apache-2.0
import Vue from 'vue';
import { polkadotIcon } from '@polkadot/ui-shared';
/**
 * @name Polkadot
 * @description The Polkadot default identicon
 */

export var Polkadot = Vue.extend({
  created: function created() {
    this.createSvgHtml();
  },
  data: function data() {
    return {
      // eslint-disable-next-line quotes
      svgHtml: "<svg viewBox=\"0 0 64 64\" />"
    };
  },
  methods: {
    createSvgHtml: function createSvgHtml() {
      var circles = polkadotIcon(this.address, {
        isAlternative: this.isAlternative || false
      }).map(function (_ref) {
        var cx = _ref.cx,
            cy = _ref.cy,
            fill = _ref.fill,
            r = _ref.r;
        return "<circle cx=".concat(cx, " cy=").concat(cy, " fill=\"").concat(fill, "\" r=").concat(r, " />");
      }).join('');
      this.svgHtml = "<svg height=".concat(this.size, " viewBox='0 0 64 64' width=").concat(this.size, ">").concat(circles, "</svg>");
    }
  },
  props: ['address', 'isAlternative', 'size'],
  // eslint-disable-next-line quotes
  template: "<div v-html=\"svgHtml\" />"
});